/*

Persistence: iframe

- Keeps audio playing when users explore the website and move between pages.
- Loads page content dynamically, without actually changing the page.
- Has a few callback options for different stage in the request lifecycle.

---

Docs:

Use the `.creek-persist` class to make elements stay in the same (parent) scope, rather than only inside the `<iframe>`.

Submit forms to parent frame by adding `target="_parent"` to your `<form>` opening tag. As a fallback, this will submit to the current frame if it's not inside an iframe.

---

TODO and NOTES:

- Vue methods for channel selector should access the methods of the parent frame.
- If channel changed, then start playing audio for that channel.

*/

var $ = require('jquery');
var jQuery = $;
var util = require('./creek-util');


//Use settings for the selected type of persistence
var persistSettings = Creek.data.persist.settings[Creek.data.persist.type];

Creek.debug.log("Persistence domain: "+persistSettings.domain, 3);

persistInstance = {};

persistInstance.url = function(url){
  window.location = url;
}

persistInstance.checkIfBrowserSupport = function(){

  if(
    // //Only supported in these browser sright now
    // util.browserChecks.chrome()
    // || util.browserChecks.safari()
    // || util.browserChecks.opera()
    // || util.browserChecks.firefox()
    // || util.browserChecks.facebook()
    !util.browserChecks.internetExplorer()
  ){
    return true;
  }
  else{
    return false;
  }

}

persistInstance.checkInsideIframe = function(){

  if(
    //Not already inside an iframe
    window.frameElement
    // && window.frameElement.id == "creek-persist-audio-iframe"
  ){
    Creek.debug.log("Persistence: Yes, inside iframe.");
    Creek.debug.log("Persistence: Iframe ID: "+window.frameElement.id);
    return true;
  }
  else{
    Creek.debug.log("Persistence: Not inside iframe.");
    return false;
  }

}

persistInstance.toolbarShow = function(){
  $('#creek-audio-toolbar')
    .css("display", "block")
    .removeClass("creek-hide");
}

persistInstance.toolbarHide = function(){
  $('#creek-audio-toolbar')
  .css("display", "none")
  .addClass("creek-hide");
}


persistInstance.getIframeSafeURL = function(url){

  var url = url || null;

  // Use the window's URL by default
  if(!url){
    var url = (' ' + window.location).slice(1);
    // var url = (' ' + window.location.href).slice(1);
  }

  // console.log(url);

  Creek.debug.log("Persistence: URL: "+url)

  //Split out the hash, since that's easier than dealing
  // with IE's lack of "/" at start of pathname.
  var url_hash = window.location.hash;
  
  Creek.debug.log("Persistence: URL hash: "+url_hash)

  if(Creek.data.persist.settings.iframe.recursionFixType == "extra-slash"){

    url_without_hash = url.replace(url_hash, "");

    Creek.debug.log("Persistence: URL without hash: "+url_hash)

    //Add the append string that prevents the browser from not working in Firefox and IE
    // These browsers won't load the same URL, since they are trying to prevent an infinite recursion of iframes.
    url = url_without_hash + "/" + url_hash;

  }

  if(Creek.data.persist.settings.iframe.recursionFixType == "question-mark"){

    url_without_hash = url.replace(url_hash, "");

    Creek.debug.log("Persistence: URL without hash: "+url_hash)

    //Add the append string that prevents the browser from not working in Firefox and IE
    // These browsers won't load the same URL, since they are trying to prevent an infinite recursion of iframes.
    url = url_without_hash + "?" + url_hash;

  }

  Creek.debug.log("Persistence: final URL to replace in main browser frame: "+url)

  return url;

}

persistInstance.filterIframeSafeURL = function(url_safe){

  Creek.debug.log("Persistence: filtering URL: ");
  Creek.debug.log(url_safe);

  var url = "";

  if(typeof url_safe.hostname != "undefined"){
    url = url_safe.href;
  }
  else{
    url = url_safe;
  }

  if(Creek.data.persist.settings.iframe.recursionFixType == "extra-slash"){

    Creek.debug.log("Persistence: removing extra slashes from: "+url);

    //Remove the extra slashes
    // var find = '//';
    // var re = new RegExp(find, 'g');
    // url_filtered = url_filtered.replace(re, '/');
    url = url.replace(/([^:]\/)\/+/g, "$1")
    
    Creek.debug.log("Persistence: after removing slashes, URL is now: "+url);

  }

  if(Creek.data.persist.settings.iframe.recursionFixType == "question-mark"){

    Creek.debug.log("Persistence: removing extra slashes from: "+url);

    //Remove the question-mark-hash
    url = url.replace("?#", "#")

    //Remove extra slashes anyway
    url = url.replace(/([^:]\/)\/+/g, "$1")

    Creek.debug.log("Persistence: after removing slashes, URL is now: "+url);

  }

  return url;

}

//!!! use this for the objects, not the above. This is otherwise confusing!!!!
// persistInstance.filterIframeSafeURL_Object = function(url_object){

//   if(typeof url_safe.hostname != "undefined"){
//     url = url_safe.hostname+url_safe.pathname+url_safe.hash;
//     console.log(2873467263487236482763487263);
//   }
//   else{
//     url = url_safe;
//   }

//   return persistInstance.filterIframeSafeURL(url);

// }


/*
Add the MAGIC IFRAME to the body that contains the current page without modification.

Notice that it includes a few special attributes:

- It's 100% width and height, with no border, so that it fills the entire window and isn't discernable as anything but a regular, non-iframed page.

- Whenever its page URL/location changes (the "onLoad" event) it calls a function that updates the parent URL of the window. Otherwise the browser's URL bar look "stuck" when you change pages.

*/
persistInstance.createIframe = function(){

  Creek.debug.log("Persistence: Creating iframe.", 3);
  Creek.debug.log("Persistence: Initial URL: "+persistInstance.getIframeSafeURL(), 3);

  $("body").addClass("creek-persist-reset-body-css");

  //Remove all DOM elements from <body> except for a few special elements.
  Creek.debug.log("Persistence: Removing DOM elements from <body> -- except for the audio toolbar (#creek-persist-audio-iframe) and any elements that have the \".creek-persist\" class.", 3);
  $("body *").not('#creek-persist-audio-iframe, creek-persist-audio-iframe *, #creek-audio-toolbar, #creek-audio-toolbar *, .creek-persist, .creek-persist *').remove();

  //Prepend the iframe to the <body>
  Creek.debug.log("Persistence: Adding <iframe> element to DOM.", 3);
  // $("body").prepend('<iframe name="creek-persist-audio-iframe" id="creek-persist-audio-iframe" src="" style="position:absolute; height:100%; width: 100%; z-index: 0; border:0; height: 1px; top:0; left:0; min-height: 100%; -webkit-overflow-scrolling: touch;" onLoad="alert(1);"></iframe>');
  $("body").prepend('<iframe name="creek-persist-audio-iframe" id="creek-persist-audio-iframe" src="" style="position:absolute; height:100%; width: 100%; z-index: 0; border:0; height: 1px; top:0; left:0; min-height: 100%; -webkit-overflow-scrolling: touch;" onLoad="try { parent.Creek.data.persist.instance.handleNewIframeURL(); } catch(e) { }"></iframe>');

  //Previous versions:
  // $("body").prepend('<iframe name="creek-persist-audio-iframe" id="creek-persist-audio-iframe" src="" style="position:absolute; height:100%; width: 100%; z-index: 0; border:0; height: 1px; top:0; left:0; min-height: 100%; -webkit-overflow-scrolling: touch;" onLoad="alert(1)"></iframe>');
  // $("body").prepend('<iframe name="creek-persist-audio-iframe" id="creek-persist-audio-iframe" src="" style="position:absolute; height:100%; width: 100%; z-index: 0; border:0; height: 1px; top:0; left:0; min-height: 100%; -webkit-overflow-scrolling: touch;" onLoad="alert(this.contentWindow.location)"></iframe>');
  // $("body").prepend('<iframe name="creek-persist-audio-iframe" id="creek-persist-audio-iframe" src="'+persistInstance.getIframeSafeURL()+'" style="position:absolute; height:100%; width: 100%; z-index: 0; border:0; height: 1px; top:0; left:0; min-height: 100%; -webkit-overflow-scrolling: touch;" onLoad="Creek.data.persist.instance.handleNewIframeURL(this.contentWindow.location);"></iframe>');

  //Start the iframe with a safe URL.
  //
  //  "Safe" means that the URL is modified so that the browser doesn't think that this 
  //  iframe will cause an infinite recursion and decide to block it from loading.
  //
  document.getElementById('creek-persist-audio-iframe').src = persistInstance.getIframeSafeURL();

}


persistInstance.checkIframeIgnoredURL = function(urlLocationObject){

  Creek.debug.log("Persistence: Checking if ignore URL: "+urlLocationObject.href);

  var urlLocationObject = urlLocationObject || null;

  if(!urlLocationObject){
    urlLocationObject = persistInstance.getCurrentIframeURL();
  }

  var ignoreThisURL = false;

  var ignoreList = Creek.data.persist.settings.iframe.ignoreURLsWith;

  var ignoreThisURL = false;
  for (var i = 0; i < ignoreList.length; i++) {
    try{
      console.log(urlLocationObject.href);
      if(urlLocationObject.href && urlLocationObject.href.indexOf && urlLocationObject.href.indexOf(ignoreList[i]) > -1){
        ignoreThisURL = true;
      }
    }catch(e){
      Creek.debug.log("Persistence: ERROR: "+urlLocationObject.href);
      console.log(e);
    }
  }

  if(ignoreThisURL){
    Creek.debug.log("Persistence: Special ignored URL: "+urlLocationObject.href);
  }
  else{
    Creek.debug.log("Persistence: Not an ignore URL: "+urlLocationObject.href);
  }

  return ignoreThisURL;

}

persistInstance.initializeMagic = function(){

  Creek.debug.log("Persistence: Initializing magic.");

  Creek.data.persist.insideIframe = persistInstance.checkInsideIframe();

  //Create iframe with the current URL
  // ...but only:
  //   - browser supports it
  //   - and if it's not already inside an iframe,
  if (
    persistInstance.checkIfBrowserSupport()
  ) {
    
    Creek.debug.log("Persistence: Browser supported.");

    if(!persistInstance.checkInsideIframe()){

      Creek.debug.log("Persistence: Checking if this is an ignored URL.");
    
      //Only create iframe if this is not an "ignored URL"
      if(!persistInstance.checkIframeIgnoredURL(window.location)){
        Creek.debug.log("Persistence: Building iframe because this is NOT an ignored URL.");
        persistInstance.createIframe();
      }
      else{
        Creek.debug.log("Persistence: Not building iframe because this is an ignored URL.");
      }

      //Whether iframe is built or not, it should still show the audio toolbar
      // since it is hidden by default (if iframe persistence is enabled)
      persistInstance.toolbarShow();

    }
    //Otherwise, don't initiate magic iframe and just hide the audio toolbar.
    else{

      Creek.debug.log("Persistence: Inside iframe: Hiding audio toolbar.");
      persistInstance.toolbarHide();

      // Build the shows router if we are inside the iframe (inside main page)
      if(typeof Creek.checkAndBuildShowsRouter != "undefined"){

        Creek.debug.log("Persistence + Router: Inside iframe: Building Vue Router.");
        Creek.checkAndBuildShowsRouter();

        //Allow for an option to build the Vue instance
        if(Creek.data.shows.buildVueInstance){
          window.$CreekShows = new Vue({
            el: "#Creek-Shows",
            router: Creek.router,
          });
        }

      }
      else{
        debug("Persistence + Router: Creek.checkAndBuildShowsRouter() is not defined.");
      }
    
    }

  }else{

    Creek.debug.log("Persistence: Browser doesn't support iframe persistence.", 3);

    //Show the audio toolbar, but only if it's not already inside an iframe
    if(persistInstance.checkInsideIframe()){
      Creek.debug.log("Hiding audio toolbar.");
      persistInstance.toolbarHide();
    }
    else{
      persistInstance.toolbarShow();
    }

  }

}

persistInstance.getCurrentIframeURL = function(){

  var urlLocationObject = null;

  try {
    urlLocationObject = document.getElementById("creek-persist-audio-iframe").contentWindow.location;
  }catch (e){
    Creek.debug.log("Persistence: ERROR:");
    Creek.debug.log(e);
  }
 
  return urlLocationObject;

}

persistInstance.handleNewIframeURL = function(urlLocationObject){

  //----------------------------------------
  // Get current iframe URL
  //

  var urlLocationObject = urlLocationObject || null;

  if(!urlLocationObject){
    urlLocationObject = persistInstance.getCurrentIframeURL();
  }
  
  //!!! Set this still, because legacy code below....
  var url = urlLocationObject;

  //If the location object is still blank, then it didn't work, so we should break out of the iframe
  if(!urlLocationObject){
    //!!! BUT THIS WILL NEVER WORK FOR XSS -- i.e. external URLs!
    window.parent.location.href = url;
  }

  //----------------------------------------
  // Now that we have the URL (or not...) continue to process stuff.
  //

  Creek.debug.log("Persistence: Updating main window URL (input): "+urlLocationObject.href);

  //Handle the initial iframe load
  if(!urlLocationObject || urlLocationObject.href == "about:blank"){
    Creek.debug.log("Persistence: Ignoring blank URL while attempting to update the main browser URL that is visible to the user.");
    return;
  }

  //----------------------------------------
  // I dunno.
  //
  //!!! testing
  if(typeof urlLocationObject == "object"){
    var url_plain_object = JSON.parse(JSON.stringify(urlLocationObject));
  }
  else{
    var url_plain_object = urlLocationObject;
  }


  //----------------------------------------
  // Get "safe URL" with stuff like "//////" or "????" removed.
  //
  // First, remove any weirdness added by the "safe iframe URL" fixer.
  var url_safe = persistInstance.filterIframeSafeURL(urlLocationObject);

  //----------------------------------------
  // Ok. Do iframe stuff.
  //
  // Make a shorthand for the iframe element
  var frame = document.getElementById("creek-persist-audio-iframe");

  if(!frame){
    Creek.debug.log(urlLocationObject);
    Creek.debug.log("Persistence: No <iframe> inside this frame (with ID: \"#creek-persist-audio-iframe\")");
    return;
  }

  Creek.debug.log("Persistence: Updating main window URL (final): "+url_safe);

  //Update page title and parent window URL
  try{

    //Update title
    var title = frame.contentDocument.title;
    document.title = title;

    //Update URL
    //
    // If the provided URL is just a hash, then just replace the hash.
    if(url_safe.charAt(0) == "#"){
      Creek.debug.log("\"It's a hash!\" -- Admiral Ackbar. ("+url_safe+")");
      window.location.hash = url_safe;
    }
    // If full URL, then replace the URL.
    else{
      window.history.replaceState("Page", title, url_safe);
    }

  }
  // Exception can be thrown on same-origin browser restriction violation
  catch(e){
    Creek.debug.log(e)
  }

  var currentURLObject = urlLocationObject;

  //-----------------------------------------------------
  // Break out of Ignored Links:
  // Check if iframe's new URL is in the ignoreLink list
  //
  if(persistInstance.checkIframeIgnoredURL()){
    Creek.debug.log("Persistence: Special ignored URL, so replacing window with: "+urlLocationObject.href);
    window.parent.location.href = urlLocationObject.href;
  }

  //-----------------------------------------------------
  // Check if current URL is an external link.
  // If so, then replace window with that URL, 
  // breaking out of iframe.
  //
  var isExternalURL = Creek.data.persist.settings.iframe.domain != currentURLObject.hostname;
  
  // If so, then replace window with href
  if(isExternalURL){
    
    Creek.debug.log("Persistence: Window switched to external URL, so breaking out of iframe: "+currentURLObject.href);
    
    window.parent.location.href = currentURLObject.href;

    // // Option 1 for external links: open link in a new browser window
    // if(Creek.data.persist.settings.iframe.externalLinkBehavior == "new-window"){
    //   window.parent.location.href = currentURLObject.href;
    // }

    // // Option 2: replace parent frame
    // if(Creek.data.persist.settings.iframe.externalLinkBehavior == "replace-window"){
    //   $(link_element).on('click', function(e){
    //     window.parent.location.href = currentURLObject.href;
    //     return false;
    //   });
    // }

  }

  //-----------------------------------------------------
  // Add "External Link" handling to <a> elements:
  //
  var iframeLinks = $(frame).contents().find("a");
  if(iframeLinks.length > 0){
    $.each(iframeLinks, function(key, link_element){
      
      // Check if externalLink
      var isExternalLink = link_element.hostname != currentURLObject.hostname;
      
      // If so, then do the selected externalLinkBehavior
      if(isExternalLink){
        
        Creek.debug.log("Persistence: Making external: "+link_element.href);
        
        // Option 1: open link in a new browser window
        if(Creek.data.persist.settings.iframe.externalLinkBehavior == "new-window"){
          $(link_element).attr('target','_blank');
        }

        // Option 2: replace parent frame
        if(Creek.data.persist.settings.iframe.externalLinkBehavior == "replace-window"){
          $(link_element).on('click', function(e){
            window.parent.location.href = link_element.href;
            return false;
          });
        }

      }

    });
  }

  //-----------------------------------------------------
  // Make "ignored links" break out of the iframe
  //
  var iframeLinks = $(frame).contents().find("a");
  if(iframeLinks.length > 0){
    $.each(iframeLinks, function(key, linkElement){

      // If so, then do the selected externalLinkBehavior
      if(persistInstance.checkIframeIgnoredURL(linkElement)){
        
        Creek.debug.log("Persistence: Making link 'ignored': "+linkElement.href);
      
        $(linkElement).on('click', function(e){
          window.parent.location.href = linkElement.href;
          return false;
        });

      }

    });
  }

  //-----------------------------------------------------
  // Make forms for external domains open new window
  //
  var iframeLinks = $(frame).contents().find("form");
  if(iframeLinks.length > 0){
    $.each(iframeLinks, function(key, formElement){
      
      var tmpLink = document.createElement('a');
      tmpLink.href = formElement.action;

      // Check if externalLink
      var isExternalForm = tmpLink.hostname != currentURLObject.hostname;
      
      // If so, then do the selected externalLinkBehavior
      if(isExternalForm){
        
        Creek.debug.log("Persistence: Making external form open new window: "+formElement.action);
        
        // Option 1 for external links: open link in a new browser window
        $(formElement).attr('target','_blank');

      }

    });
  }

}

//Change the iframe's URL
persistInstance.updateIframeURL = function(url){
  document.getElementById("creek-persist-audio-iframe").src = url;
}

//--------------------------------------------------------
//
// After page load:
//
// Perform actions on the DOM that should happen after page load.
//
$(function(){

  Creek.debug.log("Persistence loaded.", 3);

  //Create the magic iframe that contains the actual website content.
  try {
    persistInstance.initializeMagic();
  }
  catch (e){

  }

  //Links inside audio toolbar and creek-persist elements should update the iframe
  // These links have the ".creek-persist-link" class
  $(document).on("click", ".creek-persist-link", function(event){
    var url = $(this).attr("href");
    Creek.debug.log("Persistence: a special \".creek-persist-link\" was clicked. Updating the main iframe: "+url);
    persistInstance.updateIframeURL(url);
    event.preventDefault();
    return false;
  })

  //Force update the main window's URL on clicking links
  // This is useful for SquareSpace. Maybe others.
  if(Creek.data.persist.settings.forceUpdateURL){

    $(document).on("click", "a", function(event){

      var url = $(this).attr("href");

      //Ignore Vue.js router's hashbang URLs
      // so that it doesn't trigger double history entries
      // causing user to have to click back-button twice.
      if(url.indexOf("#/") !== false){
        Creek.debug.log("Persistence: Persist link clicked.");
        return;
      }

      window.parent.Creek.data.persist.instance.handleNewIframeURL(url);

    });
    
  }

})

//Export the main object
module.exports = persistInstance;




// WEBPACK FOOTER //
// ./src/creek-persist-iframe.js